<template>
  <svg
      version="1.1" id="impactlogo"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      :width="width"
      :height="height"

      viewBox="0 0 600 184.42"
      xml:space="preserve">
    <rect x="204.82" y="150.74" class="brandcolor" width="4.35" height="33.68" />
    <path class="brandcolor" d="M247.24,169.63c-0.25-4.65-0.55-10.39-0.55-14.54h-0.09c-1.19,3.9-2.52,8.2-4.21,12.8l-5.88,16.34h-3.26
	l-5.44-16.04c-1.58-4.75-2.87-9.1-3.81-13.09h-0.1c-0.1,4.2-0.34,9.84-0.64,14.89l-0.89,14.44h-4.1l2.32-33.68h5.49l5.68,16.29
	c1.38,4.15,2.47,7.9,3.36,11.39h0.1c0.89-3.4,2.08-7.14,3.56-11.39l5.93-16.29h5.49l2.08,33.68h-4.25L247.24,169.63z"/>
    <path class="brandcolor" d="M266.27,173.83l-3.46,10.59h-4.45l11.32-33.68h5.19l11.37,33.68h-4.6l-3.56-10.59H266.27z M277.2,170.43
	l-3.32-9.7c-0.69-2.2-1.18-4.2-1.68-6.15h-0.15c-0.45,1.95-0.99,4.05-1.63,6.1l-3.26,9.75H277.2z"/>
    <path class="brandcolor" d="M318.29,182.93c-1.93,0.75-5.78,1.85-10.28,1.85c-5.04,0-9.2-1.3-12.46-4.45c-2.87-2.8-4.65-7.3-4.65-12.55
	c0-10.04,6.87-17.39,18.05-17.39c3.86,0,6.92,0.85,8.35,1.55l-1.09,3.55c-1.78-0.85-4.01-1.45-7.37-1.45
	c-8.11,0-13.4,5.1-13.4,13.55c0,8.54,5.04,13.59,12.85,13.59c2.82,0,4.75-0.4,5.74-0.9v-10.04h-6.72v-3.5h10.97V182.93z"/>
    <rect x="327.24" y="150.74" class="brandcolor" width="4.35" height="33.68"/>
    <path class="brandcolor" d="M341.58,184.42v-33.68h4.75l10.63,17.04c2.43,3.95,4.4,7.49,5.93,10.95l0.15-0.05
	c-0.39-4.5-0.49-8.59-0.49-13.79v-14.14h4.05v33.68h-4.35l-10.58-17.09c-2.32-3.75-4.55-7.6-6.18-11.25l-0.15,0.05
	c0.25,4.25,0.3,8.29,0.3,13.89v14.39H341.58z"/>
    <path class="brandcolor" d="M402,182.93c-1.93,0.75-5.79,1.85-10.28,1.85c-5.04,0-9.2-1.3-12.46-4.45c-2.87-2.8-4.65-7.3-4.65-12.55
	c0-10.04,6.87-17.39,18.05-17.39c3.86,0,6.92,0.85,8.35,1.55l-1.09,3.55c-1.78-0.85-4.01-1.45-7.37-1.45
	c-8.11,0-13.4,5.1-13.4,13.55c0,8.54,5.04,13.59,12.85,13.59c2.82,0,4.75-0.4,5.74-0.9v-10.04h-6.73v-3.5H402V182.93z"/>
    <path class="brandcolor" d="M449.36,182.93c-1.93,0.75-5.79,1.85-10.28,1.85c-5.04,0-9.2-1.3-12.46-4.45c-2.87-2.8-4.65-7.3-4.65-12.55
	c0-10.04,6.87-17.39,18.05-17.39c3.86,0,6.92,0.85,8.35,1.55l-1.09,3.55c-1.78-0.85-4.01-1.45-7.37-1.45
	c-8.11,0-13.4,5.1-13.4,13.55c0,8.54,5.04,13.59,12.85,13.59c2.82,0,4.75-0.4,5.74-0.9v-10.04h-6.72v-3.5h10.97V182.93z"/>
    <path class="brandcolor" d="M458.36,151.24c2.17-0.45,5.34-0.75,8.25-0.75c4.6,0,7.62,0.9,9.7,2.8c1.63,1.45,2.62,3.75,2.62,6.4
	c0,4.4-2.82,7.35-6.28,8.54v0.15c2.52,0.9,4.05,3.3,4.89,6.8c1.09,4.69,1.88,7.95,2.52,9.25h-4.45c-0.54-1-1.28-3.85-2.17-8.05
	c-0.99-4.65-2.82-6.4-6.73-6.55h-4.05v14.6h-4.3V151.24z M462.66,166.53h4.4c4.6,0,7.52-2.55,7.52-6.4c0-4.35-3.12-6.25-7.67-6.25
	c-2.08,0-3.51,0.2-4.25,0.4V166.53z"/>
    <path class="brandcolor" d="M500.44,184.98c-8.85,0-14.98-6.9-14.98-17.09c0-10.7,6.52-17.69,15.43-17.69c9.15,0,15.03,7.05,15.03,17.04
	c0,11.55-6.97,17.74-15.43,17.74H500.44z M500.69,181.43c6.82,0,10.68-6.35,10.68-13.99c0-6.7-3.46-13.69-10.63-13.69
	c-7.17,0-10.73,6.75-10.73,14.04c0,7.1,3.86,13.64,10.63,13.64H500.69z"/>
    <path class="brandcolor" d="M528.28,150.74v19.99c0,7.49,3.32,10.69,7.76,10.69c4.89,0,8.1-3.3,8.1-10.69v-19.99h4.35v19.69
	c0,10.35-5.39,14.55-12.61,14.55c-6.82,0-11.97-3.9-11.97-14.39v-19.84H528.28z"/>
    <path class="brandcolor" d="M558.44,151.19c2.08-0.4,4.79-0.7,8.26-0.7c4.25,0,7.37,1,9.34,2.8c1.83,1.6,2.97,4.05,2.97,7
	c0,3.05-0.89,5.45-2.62,7.2c-2.28,2.45-5.99,3.7-10.19,3.7c-1.29,0-2.47-0.05-3.46-0.3v13.54h-4.3V151.19z M562.74,167.33
	c0.94,0.25,2.13,0.35,3.56,0.35c5.19,0,8.36-2.55,8.36-7.15c0-4.45-3.11-6.6-7.86-6.6c-1.88,0-3.31,0.15-4.05,0.35V167.33z"/>
    <rect y="6.5" class="brandcolor" width="28.14" height="11.25"/>
    <path class="brandcolor" d="M117.97,22.89c-14.46,0-25.66,4.62-34.58,14.41c-8.91-9.79-20.1-14.41-34.57-14.41
	c-7.73,0-14.66,1.41-20.68,4.06v-3.75H0v110.85h30.59V74.72c0-21.8,10.13-24.59,18.95-24.59c13.37,0,19.87,8.04,19.87,24.59v59.33
	h27.96V74.72c0-16.55,6.5-24.59,19.87-24.59c8.82,0,18.96,2.8,18.96,24.59v59.33h28.32V73.26
	C164.51,42.19,146.68,22.89,117.97,22.89"/>
    <path class="secondarycolor" d="M189.71,25.92v18.4c9.53-13.42,24.89-21,42.86-21c31.17,0,56.49,25.33,56.49,56.49
	c0,30.3-25.76,55.41-56.71,55.41c-18.18,0-32.25-7.14-41.77-21v70.19h-14.5V25.92H189.71z M189.5,78.52
	c0,25.76,18.18,44.37,43.73,44.37c23.37,0,42.21-19.26,42.21-43.51c0-24.03-19.05-43.73-42.64-43.73
	C208.76,35.66,189.5,54.71,189.5,78.52"/>
    <path class="secondarycolor" d="M412,132.63h-13.63v-18.62c-10.39,14.07-24.46,21.21-41.56,21.21c-31.82,0-57.79-24.89-57.79-55.41
	c0-32.03,24.89-56.49,57.36-56.49c17.53,0,32.04,7.36,41.99,21.43V25.92H412V132.63z M312.65,78.52c0,24.68,19.48,44.37,43.94,44.37
	c22.51,0,41.78-19.92,41.78-42.86c0-24.89-18.62-44.37-42.43-44.37C332.78,35.66,312.65,55.57,312.65,78.52"/>
    <path class="secondarycolor" d="M534.95,101.25c-6.71,13.2-11.91,19.05-21.86,25.33c-9.52,6.06-18.83,8.65-30.09,8.65
	c-32.9,0-58.44-24.46-58.44-55.84c0-31.17,25.76-56.06,57.79-56.06c23.59,0,44.15,13.64,52.6,34.85h-16.02
	c-8.23-14.07-22.08-22.51-36.8-22.51c-24.68,0-43.94,19.05-43.94,43.51s19.05,43.72,43.29,43.72c15.58,0,26.41-6.27,37.45-21.64
	H534.95z"/>
    <path class="secondarycolor" d="M575.35,42.91H600V30.57h-24.65V0h-12.76v30.57h-23.73v12.34h23.73v78.12c0,12.79,8.99,13.02,14.05,13.02h23.21
	v-11.69h-12.66c-10.11,0-11.84-0.72-11.84-10.53V42.91z"/>
</svg>
</template>

<script>
export default {
  name: "impact-logo",
  props: {
    width: String,
    height: String,
  },
}
</script>

<style lang="scss">
    @import 'src/styles/custom';
    .brandcolor{
      fill:$logo-primary;
    }
    .secondarycolor{
      fill:$logo-word;
    }
</style>